import { IAutoMapper } from "../../../../../../core/automapper/interfaces";
import { StringHelper } from "../../../../../../utilities/contracts/string-helper";

export const mapOverreadFeedbackDetail = (automapper: IAutoMapper): void => {
  automapper.createMap("default", "OverreadFeedbackDetail")
    .forMember("chaseOverreadFeedbackId", o => o.chaseOverreadFeedbackId)
    .forMember("chaseId", o => o.chaseId)
    .forMember("measureCode", o => o.measureCode)
    .forMember("entityTypeId", o => o.entityTypeId)
    .forMember("entityTypeName", o => o.entityTypeName)
    .forMember("codingUserId", o => o.codingUserId)
    .forMember("codingUserName", o => o.codingUserName)
    .forMember("QAUserId", o => o.QAUserId)
    .forMember("QAUserName", o => o.QAUserName)
    .forMember("codingData", o => o.codingData)
    .forMember("QAData", o => o.QAData)
    .forMember("chaseOverreadFeedbackStatus", o => o.chaseOverreadFeedbackStatus)
    .forMember("codingReceiptStatus", o => o.codingReceiptStatus)
    .forMember("QAReceiptStatus", o => o.QAReceiptStatus)
    .forMember("codingComment", o => o.codingComment)
    .forMember("QAComment", o => o.QAComment)
    .forMember("managerComment", o => o.managerComment);
};

export class OverreadFeedbackDetail {
  chaseOverreadFeedbackId: number;
  chaseId: number;
  measureCode: string;
  entityTypeId: number;
  entityTypeName: string;
  codingUserId: number;
  codingUserName: string;
  QAUserId: number;
  QAUserName: string;
  codingData: string;
  QAData: string;
  chaseOverreadFeedbackStatus: string;
  codingReceiptStatus: string;
  QAReceiptStatus: string;
  codingComment: string;
  QAComment: string;
  managerComment: string;

  constructor(options: Partial<OverreadFeedbackDetail>) {
    this.chaseOverreadFeedbackId = options.chaseOverreadFeedbackId;
    this.chaseId = options.chaseId;
    this.measureCode = StringHelper.clean(options.measureCode);
    this.entityTypeId = options.entityTypeId;
    this.entityTypeName = StringHelper.clean(options.entityTypeName);
    this.codingUserId = options.codingUserId;
    this.codingUserName = StringHelper.clean(options.codingUserName);
    this.QAUserId = options.QAUserId;
    this.QAUserName = StringHelper.clean(options.QAUserName);
    this.codingData = StringHelper.clean(options.codingData);
    this.QAData = StringHelper.clean(options.QAData);
    this.chaseOverreadFeedbackStatus = StringHelper.clean(options.chaseOverreadFeedbackStatus);
    this.codingReceiptStatus = StringHelper.clean(options.codingReceiptStatus);
    this.QAReceiptStatus = StringHelper.clean(options.QAReceiptStatus);
    this.codingComment = StringHelper.clean(options.codingComment);
    this.QAComment = StringHelper.clean(options.QAComment);
    this.managerComment = StringHelper.clean(options.managerComment);
  }
}
